import { render, staticRenderFns } from "./ActivityInstructions.vue?vue&type=template&id=284bbf58&scoped=true&"
import script from "./ActivityInstructions.vue?vue&type=script&lang=js&"
export * from "./ActivityInstructions.vue?vue&type=script&lang=js&"
import style0 from "./ActivityInstructions.vue?vue&type=style&index=0&id=284bbf58&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "284bbf58",
  null
  
)

export default component.exports